/* eslint-disable no-nested-ternary */
// @flow
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import Card from 'components/Card';
import { P } from 'components/Typography';
import Preloader from 'components/Preloader';
// import { getBreakpoints, MATRIX_TABLE } from 'utils/breakpoints';
import styles from './styles.module.scss';
// import useWindowDimensions from '../../utils/windowDemensions';

const cards = [
  'A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2',
];

function chooseEasyStyle(itemEasy, easyRFI) {
  if (!easyRFI) {
    return '';
  }

  if (!itemEasy) {
    return styles.notEasy;
  }

  return '';
}

function chooseStyleLast(x, indexX, y, indexY, arr, isEasy, isPlo5, highestCard) {
  const border = {
    border: indexX === indexY ? '3px solid #262F39' : '',
    borderRadius: indexX === indexY ? '8px' : '',
  };

  if (isPlo5) {
    const crossIndex = highestCard === 'A' ? cards.indexOf(highestCard) : cards.indexOf(highestCard) - 1;

    const card5x = arr.filter((item) => (
      item.card5 === x && item.goodSuit && indexY === crossIndex
    ));

    const card5y = arr.filter((item) => (
      item.card5 === y && !item.goodSuit && indexX === crossIndex
    ));

    if (card5x.length) {
      return (
        <div
          key={`${x}_${y}`}
          className={`${styles.cell} ${chooseEasyStyle(card5x[0]?.easy, isEasy)}`}
          style={{
            color: '#1B232F',
            background: card5x[0].color,
          }}
        >
          {`${x}`}
        </div>
      );
    }

    if (card5y.length) {
      return (
        <div
          key={`${y}_${x}`}
          className={`${styles.cell} ${chooseEasyStyle(card5y[0]?.easy, isEasy)}`}
          style={{
            color: '#1B232F',
            background: card5y[0].color,
          }}
        >
          {`${y}`}
        </div>
      );
    }

    return (
      <div
        key={`${x}__${y}`}
        className={`${styles.cell}`}
      >
        { indexX > indexY ? `${x}` : `${y}` }
      </div>
    );
  }

  const card3X = arr.filter((item) => (
    item.card3 === x
    && item.card4 === y
    && !item.goodSuit
  ));

  const card3Y = arr.filter((item) => (
    item.card3 === y
    && item.card4 === x
    && item.goodSuit
  ));

  if (card3X.length) {
    return (
      <div
        key={`${x}${y}`}
        className={`${styles.cell} ${chooseEasyStyle(card3X[0]?.easy, isEasy)}`}
        style={{
          color: '#1B232F',
          background: card3X[0].color,
          ...border,
        }}
      >
        {`${x}${y}`}
      </div>
    );
  }
  if (card3Y.length) {
    return (
      <div
        key={`${x}_${y}`}
        className={`${styles.cell} ${chooseEasyStyle(card3Y[0]?.easy, isEasy)}`}
        style={{
          color: '#1B232F',
          background: card3Y[0].color,
          ...border,
        }}
      >
        {`${y}${x}`}
      </div>
    );
  }
  if (indexX > indexY) {
    return (
      <div
        className={classnames(styles.cell)}
        style={{ ...border }}
      >
        {`${y}${x}`}
      </div>
    );
  }
  return (
    <div
      key={`${x}__${y}`}
      className={classnames(styles.cell)}
    >
      {`${x}${y}`}
    </div>
  );
}

type Props = {
  selectedCards: string,
  combination: Array<any>,
  isTableLoaded: boolean,
  isDoublesuit: boolean,
  isRainbow: boolean,
  className?: string,
  trimmed?: boolean,
  isEasy?: boolean,
  isPlo5?: boolean,
  highestCard?: string,
  isGoodSuit?: boolean,
}
// eslint-disable-next-line react/prop-types
const ModalTable = ({
  // eslint-disable-next-line max-len
  combination, isTableLoaded, selectedCards, className, trimmed = false, isDoublesuit, isRainbow, isEasy = false, isPlo5, highestCard, isGoodSuit,
}: Props) => {
  const [cardCombinations, setCardCombinations] = useState([]);
  useEffect(() => {
    setCardCombinations(combination);
  }, [combination]);

  const goodSpan = () => (
    <span style={{ color: '#FF5F5F' }}>GOOD</span>
  );

  const badSpan = () => (
    <span style={{ color: '#73B6CB' }}>BAD</span>
  );

  // const { width } = useWindowDimensions();

  return (
    <Preloader isLoading={isTableLoaded}>
      <div
        // style={{
        //   transform: `scale(${getBreakpoints(MATRIX_TABLE, 'scale', width)})`,
        //   // width: `${width < 500 ? `${width * 1.5}px` : 'auto'}`,
        //   height: 'auto',
        // }}
        className={classnames(styles.tableContainer, className)}
      >
        { !trimmed && (
          // eslint-disable-next-line no-mixed-operators, max-len
          (((selectedCards[0] === selectedCards[1] && isDoublesuit) || (isPlo5) || (!isRainbow)) && (
          <div
            className={styles.sideNotes}
          >
            <P>
              {isPlo5 ? (isGoodSuit ? (
                <span>
                  {goodSpan()}
                  {' '}
                  {badSpan()}
                </span>
              ) : (
                <span>
                  {badSpan()}
                  {' '}
                  {badSpan()}
                </span>
              )) : <span style={{ color: '#73B6CB' }}>BAD SUITED</span>}
            </P>
          </div>
          ))
        )}
        <Card use="transparent">
          <div className={styles.row}>
            <div
              className={classnames(styles.cell)}
              style={{
                // eslint-disable-next-line no-nested-ternary
                background: !isRainbow ? isDoublesuit ? '#FF1738' : '#73B6CB' : '#2C333B',
                color: '#FFFFFF',
              }}
            >
              {selectedCards}
            </div>
            {cards.map((card) => (
              <div
                key={card}
                className={classnames(styles.cardLabel, styles.cell)}
              >
                {card}
              </div>
            ))}
          </div>
          {cards.map((cardY, indexY) => (
            <div
              key={cardY}
              className={styles.row}
            >
              <div className={classnames(styles.cardLabel, styles.cell)}>{cards[indexY]}</div>
              {cards.map((cardX, indexX) => (
                <section
                  key={`${cardX}_${cardY}`}
                >
                  {chooseStyleLast(
                    cardX,
                    indexX,
                    cardY,
                    indexY,
                    cardCombinations,
                    isEasy,
                    isPlo5,
                    highestCard,
                  )}
                </section>
              ))}
            </div>
          ))}
        </Card>
        { !trimmed && (
          // eslint-disable-next-line no-mixed-operators, max-len
          (((selectedCards[0] === selectedCards[1] && isDoublesuit) || (isPlo5) || (!isRainbow)) && (
            <div
              className={styles.sideNotes}
            >
              <P>
                {isPlo5 ? (isGoodSuit ? (
                  <span>
                    {goodSpan()}
                    {' '}
                    {goodSpan()}
                  </span>
                ) : (
                  <span>
                    {badSpan()}
                    {' '}
                    {goodSpan()}
                  </span>
                )) : <span style={{ color: '#FF5F5F' }}>GOOD SUITED</span>}
              </P>
            </div>
          ))
        )}
      </div>
    </Preloader>
  );
};
export default ModalTable;
